import React from 'react';
import { Github, Linkedin, Twitter, Mail } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-gray-900 dark:bg-black text-white py-12 transition-colors" data-id="element-83">
      <div className="container mx-auto px-4 md:px-6" data-id="element-84">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-85">
          <div data-id="element-86">
            <h3 className="text-2xl font-bold mb-4" data-id="element-87">OTO</h3>
            <p className="text-gray-300 dark:text-gray-200" data-id="element-88">
              Digital Product Designer crafting innovative mobile applications
              and digital experiences.
            </p>
          </div>
          <div data-id="element-89">
            <h4 className="font-bold mb-4" data-id="element-90">Quick Links</h4>
            <ul className="space-y-2" data-id="element-91">
              <li data-id="element-92">
                <a href="#home" className="text-gray-300 dark:text-gray-200 hover:text-indigo-400 transition-colors" data-id="element-93">
                  Home
                </a>
              </li>
              <li data-id="element-94">
                <a href="#about" className="text-gray-300 dark:text-gray-200 hover:text-indigo-400 transition-colors" data-id="element-95">
                  About
                </a>
              </li>
              <li data-id="element-96">
                <a href="#projects" className="text-gray-300 dark:text-gray-200 hover:text-indigo-400 transition-colors" data-id="element-97">
                  Projects
                </a>
              </li>
              <li data-id="element-98">
                <a href="#contact" className="text-gray-300 dark:text-gray-200 hover:text-indigo-400 transition-colors" data-id="element-99">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-100">
            <h4 className="font-bold mb-4" data-id="element-101">Connect</h4>
            <div className="flex space-x-4" data-id="element-102">
              <a href="#" className="bg-gray-800 dark:bg-gray-900 p-2 rounded-full hover:bg-indigo-600 dark:hover:bg-indigo-500 transition-colors" aria-label="Github" data-id="element-103">
                <Github size={20} data-id="element-104" />
              </a>
              <a href="#" className="bg-gray-800 dark:bg-gray-900 p-2 rounded-full hover:bg-indigo-600 dark:hover:bg-indigo-500 transition-colors" aria-label="LinkedIn" data-id="element-105">
                <Linkedin size={20} data-id="element-106" />
              </a>
              <a href="#" className="bg-gray-800 dark:bg-gray-900 p-2 rounded-full hover:bg-indigo-600 dark:hover:bg-indigo-500 transition-colors" aria-label="Twitter" data-id="element-107">
                <Twitter size={20} data-id="element-108" />
              </a>
              <a href="#" className="bg-gray-800 dark:bg-gray-900 p-2 rounded-full hover:bg-indigo-600 dark:hover:bg-indigo-500 transition-colors" aria-label="Email" data-id="element-109">
                <Mail size={20} data-id="element-110" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 dark:border-gray-700 pt-8 text-center" data-id="element-111">
          <p className="text-gray-400 dark:text-gray-300" data-id="element-112">
            © 2024 OTO Design. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};